// src/components/NotFound404.jsx
import React from "react";
import styled from "styled-components";


// Styled Components
const Page404 = styled.section`
  padding: 40px 0;
  background: #fff;
  font-family: "Arvo", serif;
  overflow: hidden;
  text-align: center;

  .four_zero_four_bg {
background-image: url("/404.gif");
    height: 500px;
    background-position: center;
    background-repeat: no-repeat;
  }

  .four_zero_four_bg h1 {
    font-size: 80px;
    margin: 0;
  }

  .contant_box_404 {
    margin-top: -50px;
  }

  .contant_box_404 h3 {
    font-size: 24px;
    font-weight: bold;
    margin-bottom: 10px;
  }

  .contant_box_404 p {
    font-size: 16px;
    color: #555;
  }

  .link_404 {
    color: #fff;
    padding: 10px 20px;
    background: #39ac31;
    margin-top: 20px;
    display: inline-block;
    border-radius: 4px;
    text-decoration: none;
    transition: background 0.3s ease;

    &:hover {
      background: #2d8626;
    }
  }
`;

// Component
const NotFound404 = ({ homeLink = "/", mode = "404" }) => {
  const isOffline = mode === "offline";

  return (
    <Page404>
      <div className="four_zero_four_bg">
        <h1>{isOffline ? "Offline" : "404"}</h1>
      </div>

      <div className="contant_box_404">
        <h3>
          {isOffline ? "No Internet Connection" : "Looks like you're lost"}
        </h3>
        <p>
          {isOffline
            ? "Please check your network settings and try again."
            : "The page you are looking for is not available!"}
        </p>
        <a href={homeLink} className="link_404">
          {isOffline ? "Retry" : "Go to Home"}
        </a>
      </div>
    </Page404>
  );
};

export default NotFound404;
